import {
  createBrowserRouter,
  createHashRouter,
  type RouterProviderProps,
} from "react-router-dom";
import { usesHashRouter } from "./config/storefrontRouting";
import { createRoutes } from "./routes";

/**
 * Main router configuration
 *
 * Uses createHashRouter instead of createBrowserRouter because Electron
 * loads pages via the file:// protocol in production. The HTML5 History
 * API (pushState) does not work with file:// URLs — the browser interprets
 * the full filesystem path as the route, so every page would 404.
 *
 * Hash routing (e.g. index.html#/ , index.html#/about) works identically
 * under both http:// (dev server) and file:// (packaged Electron).
 */
export function createAppRouter(): RouterProviderProps["router"] {
  const routes = createRoutes();
  return usesHashRouter()
    ? createHashRouter(routes)
    : createBrowserRouter(routes);
}
